import {Component, ElementRef, EventEmitter, Output, ViewChild, inject} from '@angular/core';
import {DeliveryService} from "../../../../services/delivery.service";
import {takeUntil} from "rxjs/operators";
import {DeliveryWarehouse} from "../../../../interfaces/delivery-warehouse";
import {
  MessageDeliveryDLConfirmComponent
} from "../../messages/message-delivery-dl-confirm/message-delivery-dl-confirm.component";
import {HttpClient} from "@angular/common/http";
import {LocalStorageService} from "../../../../services/local-storage.service";
import {Router} from "@angular/router";
import * as moment from "moment";
import {OrganizationsService} from "../../../../services/organizations.service";
import {Organization} from "../../../../interfaces/organization";

@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['../../../basket-confirm/basket-confirm.component.scss']
})
export class DeliveryComponent extends DeliveryService {
  @ViewChild('phoneRef') override phoneRef: ElementRef<HTMLInputElement>;
  @ViewChild('scrollInputRef') scrollInputRef: ElementRef<HTMLInputElement>;
  @ViewChild(MessageDeliveryDLConfirmComponent) messageDeliveryDLConfirmComponentRef: MessageDeliveryDLConfirmComponent
  @Output() selectedDeliveryType = new EventEmitter<number>();

  private organizationsService = inject(OrganizationsService);

  isDeliveryAddress = false;
  wrongDeliveryCityId = false;
  warehouses;
  wrongDeliveryWarehouse = false;
  reserve = false;
  deliveryBeznal = false;
  deliveryAddress = '';
  deliveryCityId = -1;
  deliveryWarehouse;
  wrongDeliveryAddres = false;
  reserveTimeOk = true;
  private isUserChangedDeliveryDate = false;
  public activeOrganization: Organization;

  constructor(
    http: HttpClient,
    localStorage: LocalStorageService,
    private router: Router
  ) {
    super(http, localStorage);

    this.organizationsService.organizations$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((organizations: Organization[]) => {
        this.activeOrganization = organizations.find(org => org.is_active === '1' || org.is_active === true);
      });
  }

  override scrollToInvalidForm() {
    if (this.wrongEstimateOfTheCostOfTheOrder ||
      this.wrongLastAddressEdrpou ||
      this.wrongDeliveryDates ||
      this.wrongDeliveryCityId) {
      this.scrollInputRef.nativeElement.scrollIntoView();
    } else if (this.wrongLastAddressEdrpou) {
      this.scrollInputRef.nativeElement.scrollIntoView();
    } else if (this.wrongDeliveryWarehouse) {
      this.scrollInputRef.nativeElement.scrollIntoView();
    } else if (this.isDeliveryAddress) {
      if (this.wrongDeliveryAddres) {
        this.scrollInputRef.nativeElement.scrollIntoView();
      }
    }
  }

  setDeliveryCity() {
    return new Promise((resolve) => {
      this.validateDeliveryCity();

      this.http.post(this.apiRoot + 'basket_data/get_delivery_warehouses', {
        city_id: this.deliveryCityId
      })
        .pipe(takeUntil(this.isDestroyed))
        .subscribe((data: DeliveryWarehouse[]) => {
          this.warehouses = data && data.length > 0 ? data : [];

          // Разом з містом змінюється і список відділень: раніше обраного
          // відділення у ньому може вже не бути, тож скидаємо вибір,
          // інакше у заявку пішов би номер з іншого міста.
          if (!this.findWarehouse(this.deliveryWarehouse)) {
            this.deliveryWarehouse = -1;
          }

          if (this.warehouses.length === 1) {
            this.deliveryWarehouse = this.warehouses[0].id;
          }

          resolve(true);
        });
    });
  }

  override async validate() {
    if (this.lastAddress.delivery_city_id) {
      this.deliveryCityId = this.lastAddress.delivery_city_id;

      // як у НП: без права del_allow_beznal галочка й ЄДРПОУ приховані, а безнал з минулої адреси
      // все одно йшов у замовлення (pay() право не перевіряє) і вимкнути його було нічим
      if (this.user.del_allow_beznal && this.lastAddress.yur_lico && this.lastAddress.edrpou) {
        this.deliveryBeznal = true;
      }

      // як у НП: при вимкненій адресній доставці перемикача немає (setIsDeliveryAddress теж
      // виходить), і клієнт з адресою в минулому замовленні застрягав у ній без шляху до відділення
      if (this.lastAddress.delivery_addr && this.addressedDelivery) {
        this.isDeliveryAddress = true;
        this.deliveryAddress = this.lastAddress.delivery_addr;
      }

      await this.setDeliveryCity();

      // Відділення з минулого замовлення підставляємо лише якщо воно є
      // у поточному списку (могло закритись або належати іншому місту).
      if (this.lastAddress.delivery_warehouse_id
        && this.findWarehouse(this.lastAddress.delivery_warehouse_id)) {
        this.deliveryWarehouse = this.lastAddress.delivery_warehouse_id;
      }
    }
  }

  // Місто/відділення вважаємо обраними лише тоді, коли вони справді є
  // у поточних списках: інакше далі впаде find(...).city / find(...).name
  // і користувач не побачить жодної підказки.
  private findDeliveryCity(id) {
    if (id === undefined || id === null || id == -1) {
      return undefined;
    }

    return (this.deliveryCities || []).find(val => val.id == id);
  }

  private findWarehouse(id) {
    if (id === undefined || id === null || id == -1) {
      return undefined;
    }

    return (this.warehouses || []).find(val => val.id == id);
  }

  validateDeliveryCity() {
    if (!this.findDeliveryCity(this.deliveryCityId)) {
      this.wrongDeliveryCityId = true;
      this.isValidDeliveryForm = true;

      this.wrongDeliveryCityId = this.delivery === 5;

    } else {
      this.wrongDeliveryCityId = false;
    }
  }

  setDeliveryWarehouse() {
    if (!this.findWarehouse(this.deliveryWarehouse)) {
      this.wrongDeliveryWarehouse = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryWarehouse = false;
    }
  }

  setIsDeliveryAddress() {
    if (!this.addressedDelivery) {
      return;
    }

    this.isDeliveryAddress = !this.isDeliveryAddress;
    this.inputDeliveryAddressChange();
  }

  inputDeliveryAddressChange() {
    if (this.deliveryAddress === null || this.deliveryAddress.length < 5) {
      this.wrongDeliveryAddres = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryAddres = false;
    }
  }

  crossClearAddress() {
    this.deliveryAddress = '';
    this.inputDeliveryAddressChange();
  }

  deliveryGoodsReserve() {
    this.reserve = !this.reserve;
  }

  setDeliveryBeznal() {
    this.deliveryBeznal = !this.deliveryBeznal;
    this.inputLastAddressEdrpou();
  }

  onUserChangeDeliveryDate() {
    this.isUserChangedDeliveryDate = true;
    this.changingValueDeliveryDate();
  }

  changingValueDeliveryDate() {
    const currentDate = moment().format('DD.MM.YYYY');
    const isCurrentDate = this.deliveryDate.toString() === currentDate;

    const now = new Date();
    const currentTime = now.getHours() * 60 + now.getMinutes();

    const startReserveTime = 0; // "00:00" в минутах
    const endReserveTime = 16 * 60 + 30; // "16:30" в минутах
    const currentTimeLessThen_16_30 = currentTime >= startReserveTime && currentTime < endReserveTime;

    if (this.deliveryDate == -1 && !this.dozakazDate) {
      this.wrongDeliveryDates = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryDates = false;
    }

    this.reserveTimeOk = !(isCurrentDate && !currentTimeLessThen_16_30);
    // переключатель «Резерв» скрыт — сбрасываем, чтобы резерв не ушёл с заказом
    if (!this.reserveTimeOk) {
      this.reserve = false;
    }

    if (this.deliveryDate != -1 && this.deliveryCurrent && this.deliveryCurrent.delivery_hours && this.deliveryCurrent.delivery_hours[this.deliveryDate]) {
      this.deliveryHoursList = this.deliveryCurrent.delivery_hours[this.deliveryDate];
    } else {
      this.deliveryHoursList = [];
    }

    if (this.isUserChangedDeliveryDate) {
      this.deliveryHours = -1;
      this.wrongDeliveryHours = false;
      this.isUserChangedDeliveryDate = false;
    }
  }

  changingValueDeliveryHours() {
    if (!this.deliveryHoursList?.length) {
      this.wrongDeliveryHours = false;
      return;
    }

    if (this.deliveryHours == -1 && !this.dozakazDate) {
      this.wrongDeliveryHours = true;
      this.isValidDeliveryForm = true;
    } else {
      this.wrongDeliveryHours = false;
    }
  }

  switchesDeliveryType(id: number) {
    this.selectedDeliveryType.emit(id);
  }

  override validateSendPayment() {
    this.isValidDeliveryForm = false;
    const sendData = {
      delivery_id: this.delivery
    };

    if (this.isDeliveryAddress) {
      this.inputDeliveryAddressChange();
      sendData['delivery_addr'] = this.deliveryAddress
    }

    sendData['reserved_by_user'] = 0;

    if (this.reserve && this.reserveTimeOk) {
      sendData['reserved_by_user'] = 1;
    }

    if (this.deliveryBeznal) {
      this.inputLastAddressEdrpou();
      sendData['edrpou'] = this.lastAddress.edrpou;
    }

    sendData['beznal'] = this.deliveryBeznal;

    this.setDeliveryWarehouse();
    this.validateDeliveryCity();
    const isBuOrganization = this.activeOrganization && this.activeOrganization.type !== 'fiz';
    if (!isBuOrganization) {
      this.inputEstimateOfTheCostOfTheOrder();
    }
    this.inputLastName();
    this.inputName();
    this.inputMiddleName();
    this.inputLastAddressPhone();
    this.changingValueDeliveryDate();
    this.changingValueDeliveryHours();

    if (!this.isValidDeliveryForm) {
      // Форма валідна, отже validateDeliveryCity()/setDeliveryWarehouse() вище
      // вже переконались, що обране місто й відділення є у своїх списках.
      const selectedCity = this.findDeliveryCity(this.deliveryCityId);
      const selectedWarehouse = this.findWarehouse(this.deliveryWarehouse);

      sendData['delivery_city_id'] = this.deliveryCityId;
      sendData['address'] = selectedCity.city;
      sendData['courier_num_id'] = this.deliveryWarehouse;
      sendData['courier_num'] = selectedWarehouse.name;
      sendData['declared_price'] = this.declaredPrice;
      sendData['fio'] = `${this.lastName} ${this.name} ${this.middleName || ''}`;
      sendData['phone'] = this.phoneRef.nativeElement.value.replace(/\+38/g, '').replace(/\D/g, '');
      sendData['delivery_date'] = this.deliveryDate;

      sendData['delivery_hour'] = '';

      if (this.deliveryHoursList?.length && this.deliveryHours !== -1) {
        sendData['delivery_hour'] = this.deliveryHours;
      }

      sendData['comment'] = this.deliveryComment;
    }

    // Дати переміщення бек рахує лише по підзамовних товарах: для кошика зі складів 1+7 без них список
    // порожній, а вибір обов'язковий - форма не відправлялась. Без delivery_date_zak бек бере delivery_date.
    if (this.separateOrders && this.deliveryCurrent?.delivery_dates_zak?.length) {
      this.changingValueDeliverySeparate();

      sendData['delivery_date_zak'] = this.deliverySeparate;
    }

    return sendData;
  }

  override resultSendPayment(data) {
    if (data.error === '' && data.data.order_id) {
      data.data.delivery = this.delivery;
      this.isDeliveryConfirmation = true;
      this.messageDeliveryDLConfirmComponentRef.deliveryDLConfirmationShow(data);
    }

    if (data.error === 'empty basket') {
      this.router.navigate(['account']);
    }

    if (data.error === 'too many orders') {
      this.router.navigate(['account']);
    }

    if (data.error === 'not_enough_liters') {
      this.router.navigate(['basket']);
    }
  }
}
